import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

function addOffset(apiUrl, data) {
  if (data?.offset !== undefined) {
    apiUrl += `&offset=${data.offset * 20}`;
  }
  return apiUrl;
}

function addNameOrEmail(data, apiUrl) {
  if (
    data?.nameOrEmail !== null &&
    data?.nameOrEmail !== undefined &&
    data?.nameOrEmail !== ""
  ) {
    apiUrl += `&nameOrEmail=${data.nameOrEmail}`;
  }
  return apiUrl;
}

function addBu(data, apiUrl) {
  if (data?.BU !== null && data?.BU !== undefined) {
    apiUrl += `&businessUnitId=${data.BU}`;
  }
  return apiUrl;
}

function addCompetency(data, apiUrl) {
  if (data?.competency !== null && data?.competency !== undefined) {
    apiUrl += `&competencyIds=${data.competency}`;
  }
  return apiUrl;
}

function addDesignation(data, apiUrl) {
  if (
    data?.designation !== null &&
    data?.designation !== undefined &&
    data?.designation?.length
  ) {
    apiUrl += `&designationIds=${data.designation}`;
  }
  return apiUrl;
}

function addRm(data, apiUrl) {
  if (
    data?.reportingManagerNameOrEmail !== null &&
    data?.reportingManagerNameOrEmail !== undefined &&
    data?.reportingManagerNameOrEmail !== ""
  ) {
    apiUrl += `&reportingManagerNameOrEmail=${data.reportingManagerNameOrEmail}`;
  }
  return apiUrl;
}

function addMentor(data, apiUrl) {
  if (
    data?.mentorNameOrEmail !== null &&
    data?.mentorNameOrEmail !== undefined &&
    data?.mentorNameOrEmail !== ""
  ) {
    apiUrl += `&mentorNameOrEmail=${data.mentorNameOrEmail}`;
  }
  return apiUrl;
}

function addRoles(data, apiUrl) {
  if (
    data?.roles?.length &&
    data?.roles !== null &&
    data?.roles !== undefined
  ) {
    apiUrl += `&roles=${data.roles}`;
  }
  return apiUrl;
}

function addSortBy(data, apiUrl) {
  if (data?.sortBy) {
    apiUrl += `&sortBy=${data?.sortBy}`;
  }
  return apiUrl;
}

function addSortOrder(data, apiUrl) {
  if (data?.sortOrder) {
    apiUrl += `&sortOrder=${data?.sortOrder}`;
  }
  return apiUrl;
}

export function getUsersApi(data) {
  let apiUrl = `${apiBasePath}/users?max=20`;

  apiUrl = addOffset(apiUrl, data);
  apiUrl = addNameOrEmail(data, apiUrl);
  apiUrl = addBu(data, apiUrl);
  apiUrl = addCompetency(data, apiUrl);
  apiUrl = addDesignation(data, apiUrl);
  apiUrl = addRm(data, apiUrl);
  apiUrl = addMentor(data, apiUrl);
  apiUrl = addRoles(data, apiUrl);
  apiUrl = addSortBy(data, apiUrl);
  apiUrl = addSortOrder(data, apiUrl);

  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };

  return ApiService(options);
}

export function getCompetenciesApi(data) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/competencies`,
    data: data,
  };
  return ApiService(options);
}

export function getDesignationApi(data) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/designations?competencyId=${data}`,
    data: data,
  };
  return ApiService(options);
}

export function deleteUserRoleApi(data) {
  const options = {
    method: "DELETE",
    url: `${apiBasePath}/users/${data.userId}/roles/${data.roleName}`,
    data: data,
  };
  return ApiService(options);
}

export function addUserRoleApi(data) {
  const options = {
    method: "POST",
    url: `${apiBasePath}/users/${data.userId}/roles/${data.roleName}`,
    data: data,
  };
  return ApiService(options);
}

export function syncDataApi(data) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/nw/middleware/dataSync`,
    data: data,
  };
  return ApiService(options);
}

export function getBussinessUnitsApi(data) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/businessUnits`,
    data: data,
  };
  return ApiService(options);
}


export function getFiltersForUsersApi() {
  const options = {
    method: "GET",
    url: `${apiBasePath}/utilities/filtersForUsersListing`,
  };
  return ApiService(options);
}